<template>
  <div v-loading ="isLoading">
    <button @click="handleRemoveAttachmentFromLamps()" class="btn btn-danger btn-fill btn-wd"
      title="Essa rotina remove todos os attachments vazios de lâmpadas.">
      Remover Attachments Vazios de Lâmpadas
    </button>
    <el-progress :percentage="progressPercentage"></el-progress>
  </div>
</template>
<script>
import Couchdb from 'src/services/Couchdb'
import swal from 'sweetalert2'

export default {
  data () {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    }
  },
  computed: {
    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      return parseInt((this.progress / this.total) * 100)
    }
  },
  methods: {
    handleRemoveAttachmentFromLamps () {
      this.isLoading = true
      this.total = 0
      Couchdb.collection('lamps').all()
      .then(docs => {
        this.isLoading = false
        let docsWithEmptyAttachment = docs.filter(doc => {
          if (doc._attachments && doc._attachments['documents.pdf'].length === 0) {
            return true
          }
          return false
        })
        this.total = docsWithEmptyAttachment.length
        let swalOptions = {
          title: `Existem ${docsWithEmptyAttachment.length} documento(s)</b> com attachment vazio.`
        }
        if (docsWithEmptyAttachment.length === 0) {
          swal({
            title: swalOptions.title,
            text: `Todos os documentos vazios já foram removidos.`,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
        } else {
          swal({
            title: swalOptions.title,
            html: `Você deseja remover os attachments?`,
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Sim, desejo remover!',
            cancelButtonText: 'Não',
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          })
          .then(async () => {
            for (const item of docsWithEmptyAttachment) {
              await this.exec(item)
              .then(result => {
                if (this.progress === this.total) {
                  this.notifyFinish()
                }
              })
              .catch(err => {
                swal({
                  width: 1000,
                  title: 'Ocorreu um erro ao executar essa ação.',
                  text: JSON.stringify(err),
                  type: 'error',
                  confirmButtonClass: 'btn btn-danger btn-fill',
                  buttonsStyling: false
                })
              })
            }
          })
        }
      })
      .catch(err => {
        console.log(err)
        this.isLoading = false
      })
    },
    async exec (item) {
      let deleted = await Couchdb.deleteAttachment(item._id, {
        attachmentName: 'documents.pdf'
      })
      this.progress++
      return deleted
    },
    notifyFinish () {
      swal({
        title: 'Sucesso',
        text: `Todos os documentos vazios foram removidos.`,
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/commands/RemoveAttachmentFromLamps.vue